import { useEffect } from "react";

const ScoreA11yWidget = () => {
  useEffect(() => {
    const identificador = window?.env?.RAZZLE_SCORE_A11Y_ID || process.env.RAZZLE_SCORE_A11Y_ID || "";
    const ambiente = window?.env?.RAZZLE_SCORE_A11Y_ENV || process.env.RAZZLE_SCORE_A11Y_ENV || "";

    if (!identificador || !ambiente) {
      return;
    }

    // Verificar se o script já foi inserido
    if (document.querySelector('script[src="https://cdn-scorea11y.estaleiro.serpro.gov.br/a11y-tracking.js"]')) {
      return;
    }

    // Definir as variáveis globais antes de carregar o script
    const identificadorScript = document.createElement("script");
    identificadorScript.textContent = `
      window.identificador = "${identificador}";
      window.ambiente = "${ambiente}";
    `;
    document.body.appendChild(identificadorScript);

    // Carregar o script principal
    const script = document.createElement("script");
    script.src = "https://cdn-scorea11y.estaleiro.serpro.gov.br/a11y-tracking.js";
    script.async = true;

    // Adicionar um evento para verificar se o script foi carregado
    script.onload = () => {
      // Executar o código no evento DOMContentLoaded após o script ser carregado
      const Ne = {
        amb1: "desenvolvimento",
        amb2: "teste",
        amb3: "homologação",
        amb4: "produção",
      };
      if (window.identificador === void 0) {
        throw new Error("identificador do sistema não foi definido: verificar em https://meudominio.serpro.gov.br");
      }
      if (window.ambiente !== void 0) {
        if (Object.values(Ne).find((ke) => ke === window.ambiente) === void 0) {
          throw new Error("ambiente definido não é válido, use: desenvolvimento|teste|homologação|produção");
        }
      } else {
        throw new Error("É necessário especificar o ambiente, use: window.ambiente");
      }
      window.a11y.watch();

      console.log("Script de acessibilidade carregado com sucesso.");
    };

    script.onerror = () => {
      console.error("Erro ao carregar o script de acessibilidade.");
    };

    document.body.appendChild(script);

    return () => {
      script.remove();
      identificadorScript.remove();
    };
  }, []);

  return null;
};

export default ScoreA11yWidget;
